export const contactsData = {
    email: 'rafay51698@gmail.com',
    phone: '+923202234131',
    address: 'University Road , Karachi ',

    sheetAPI: ''
}